import * as berachain from '@/assets/data/contracts/berachain.json';
import { Pools } from '@/types/pools';

/*
 * FX Pool Factories
 *
 * @returns {Record<string, string>} - A record of quote token addresses to their corresponding FXPoolDeployer addresses.
 *
 * !Important: The FxPoolDeployer address must be in lower case.
 */
const fxPoolFactories = {
  // USDC.e
  '0x549943e04f40284185054145c6e4e9568c1d3241':
    '0x49c2859b4bd8b7fc1f79fb037b16815983c26ce7',
};

const pools: Pools = {
  IdsMap: {},
  Pagination: {
    PerPage: 10,
    PerPool: 10,
    PerPoolInitial: 5,
  },
  BoostsEnabled: false,
  DelegateOwner: '0xba1ba1ba1ba1ba1ba1ba1ba1ba1ba1ba1ba1ba1b',
  ZeroAddress: '0x0000000000000000000000000000000000000000',
  DynamicFees: {
    Gauntlet: [],
  },
  BlockList: [
    '0x0b3ce9a5d7403f9a61a396d9fdd8f178ae734a12000200000000000000000001',
    '0x04c34cbe8dbe95188bce65808e5ba1b44a80b315000200000000000000000002',
    '0xf9154f85947e09efec7aefe0de55bbff796854d7000000000000000000000003',
    '0xebff6ef6a2f53b2ec29f47f9ccedcb5e6e7978cb000000000000000000000005',
    '0x412fd1939df8716b616b603ee582074c1e40bb6d000200000000000000000007',
  ],
  IncludedPoolTypes: ['Weighted', 'ComposableStable', 'FX'],
  Stable: {
    AllowList: [
      // berachain mainnet doesn't require allow listing of pools
      // instead we tag pools with 'Curated' and filter the UI
      // to show Curated pools only by default
    ],
  },
  Investment: {
    AllowList: [],
  },
  Weighted: {
    // Only effective after given timestamp here: usePool.ts#createdAfterTimestamp
    // see useDisabledJoinPool.ts#nonAllowedWeightedPoolAfterTimestamp for logic.
    AllowList: [],
  },
  Factories: {
    [berachain.WeightedPoolFactory]: 'weightedPool',
    [berachain.ComposableStablePoolFactory]: 'composableStablePool',
    // append fxPoolFactories to the factories
    ...Object.fromEntries(
      Object.values(fxPoolFactories).map(factory => [factory, 'fx'])
    ),
  },
  Stakable: {
    VotingGaugePools: [],
    AllowList: [
      // deprecated: burrbear is now using rewards subgraph to determine if pool is stakeable or not
    ],
    External: [
      // {
      //   // BERA:HONEY pool
      //   poolAddress: '0xb6b6e240291a4d433a94279c1a68f85e2bf24857',
      //   subgraphUrl:
      //     'https://api.goldsky.com/api/public/project_cm0keevd9v59l01w4fokhdcg9/subgraphs/hpot-algebra-core/2.0.3/gn',
      //   manageLiquidityUrl: 'https://wasabee.honeypotfinance.xyz/pool-detail/',
      // },
    ],
  },
  Metadata: {},
  Deep: [],
  BoostedApr: [],
  DisabledJoins: [], // may contain pool ids with security issues
  NewVersionAvailable: {},
  Deprecated: {}, // for pool migration?
  GaugeMigration: {},
  BrandedRedirect: {},
  ExitViaInternalBalance: [],
  Issues: {},
  FXPoolFactories: fxPoolFactories,
};

export default pools;
